import { Configuration, SmartContractsApi } from '@stacks/blockchain-api-client';

export function getContractInterface(
  contractName: string,
  contractAddress: string,
  isTestnet: boolean
) {
  const basePath = `https://stacks-node-api.${isTestnet ? 'testnet' : 'mainnet'}.stacks.co`;
  const smartContractsApi = new SmartContractsApi(
    new Configuration({
      basePath,
    })
  );

  return smartContractsApi.getContractInterface({
    contractAddress: contractAddress as unknown as string,
    contractName: contractName as unknown as string,
  });
}
